'use client'
import React, { useCallback } from 'react'
import styles from './styles.module.scss'
import Button from './Button'

interface AmountRangeProps {
  value: number
  step: number
  onUpdate: (value: number) => void
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
  helperText?: string
}

const AmountRange: React.FC<AmountRangeProps> = ({
  value,
  step,
  onUpdate,
  onFocus,
  helperText,
}) => {
  const onChangeHandler = useCallback(
    value => {
      if (typeof value === 'number') onUpdate(value)
      else {
        const newValue = Number(String(value?.target?.value).replace(/\D/, ''))
        onUpdate(newValue)
      }
    },
    [onUpdate],
  )
  const onButtonClick = useCallback(
    type => {
      const updatedValue =
        type === 'minus' ? Number(value) - step : Number(value) + step
      onChangeHandler(updatedValue)
    },
    [onChangeHandler, step, value],
  )

  return (
    <div>
      <div className={styles.container}>
        <Button
          type="minus"
          onClick={onButtonClick}
          disabled={Number(value) <= 0}
        />

        <input
          className={styles.input}
          onChange={onChangeHandler}
          value={value}
          onFocus={onFocus}
        />
        <Button type="plus" onClick={onButtonClick} />
      </div>
      {helperText && <div className={styles.helper}>{helperText}</div>}
    </div>
  )
}

export default AmountRange
